

import { Link } from "react-router-dom";
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const Login = () => {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <div className="copyright text-center text-xl-left text-muted">
                © {new Date().getFullYear()}{" "}
                <span className="font-weight-bold ml-1">
                  Destinasyon 360
                </span>
              </div>
            </Col>
            <Col xl="6">
              <Nav className="nav-footer justify-content-center justify-content-xl-end">
                <NavItem>
                  <NavLink to="/admin/index" tag={Link}>Destinasyon 360</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/destek" tag={Link}>Destek</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/privacy-policy" tag={Link}>Gizlilik Politikası</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/user-privacy" tag={Link}>Kullanıcı Gizliliği</NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
